import ListGroup from '@pelckmans/elementis/components/list-group';
import List from '@pelckmans/elementis/components/list';
import Tooltip from '@pelckmans/elementis/components/tooltip';
import InfoIcon from '@pelckmans/elementis/icons/info';
import SuccessIcon from '@pelckmans/elementis/icons/success';
import PendingIcon from '@pelckmans/elementis/icons/pending';
import { useTranslation } from 'react-i18next';
import Pill from '@pelckmans/elementis/components/pill';
import { useMemo } from 'react';
import { Group, Member } from '../../../../../../api/groups';

type Props = {
  group: Group;
  members: Member[];
};

function ListGroupSmartschool({ group, members }: Props) {
  const { t } = useTranslation();

  const acceptedMembers = useMemo(() => members.filter(member => member.status === 'accepted'), [members]);
  const pendingMembers = useMemo(() => members.filter(member => member.status === 'pending'), [members]);

  return (
    <ListGroup>
      <List density="compact">
        <List.Header
          title={t('PAGES.MY_GROUPS.MODALS.GROUP_DETAILS.TABS.STUDENTS.BODY.LIST_GROUP.SMARTSCHOOL.ACCEPTED.TITLE')}
          pill={
            <Pill icon={<SuccessIcon data-testid="success-icon" />} prominence="success" size="sm">
              {String(group.totalAccepted)}
            </Pill>
          }
          titleTag="h3"
          tooltip={
            <Tooltip anchor={<InfoIcon data-testid="tooltip-accepted" />} truncation="wrapped">
              <p>
                {t('PAGES.MY_GROUPS.MODALS.GROUP_DETAILS.TABS.STUDENTS.BODY.LIST_GROUP.SMARTSCHOOL.ACCEPTED.TOOLTIP')}
              </p>
            </Tooltip>
          }
        />
        {acceptedMembers.length === 0 && (
          <List.Item
            title={t('PAGES.MY_GROUPS.MODALS.GROUP_DETAILS.TABS.STUDENTS.BODY.LIST_GROUP.SMARTSCHOOL.ACCEPTED.EMPTY')}
          />
        )}
        {acceptedMembers.map(member => (
          <List.Item
            key={member.id}
            title={[member.lastName, member.firstName].join(' ')}
            subText={member.primaryEmail}
          />
        ))}
      </List>

      <List density="compact">
        <List.Header
          title={t('PAGES.MY_GROUPS.MODALS.GROUP_DETAILS.TABS.STUDENTS.BODY.LIST_GROUP.SMARTSCHOOL.PENDING.TITLE')}
          pill={
            <Pill icon={<PendingIcon data-testid="pending-icon" />} prominence="warning" size="sm">
              {String(group.totalPending)}
            </Pill>
          }
          titleTag="h3"
          tooltip={
            <Tooltip anchor={<InfoIcon data-testid="tooltip-smartschool-pending" />} truncation="wrapped">
              <p>
                {t('PAGES.MY_GROUPS.MODALS.GROUP_DETAILS.TABS.STUDENTS.BODY.LIST_GROUP.SMARTSCHOOL.PENDING.TOOLTIP')}
              </p>
            </Tooltip>
          }
        />
        {pendingMembers.length === 0 && (
          <List.Item
            title={t('PAGES.MY_GROUPS.MODALS.GROUP_DETAILS.TABS.STUDENTS.BODY.LIST_GROUP.SMARTSCHOOL.PENDING.EMPTY')}
          />
        )}
        {pendingMembers.map(member => (
          <List.Item key={member.id} title={[member.lastName, member.firstName].join(' ')} />
        ))}
      </List>
    </ListGroup>
  );
}

export default ListGroupSmartschool;
